import { twMerge } from 'tailwind-merge';

import { Cell } from '../Cell';

export const CallersByClientTable = ({ data, pdfMode = false }) => {
  const total = data.metrics[data.metrics.length - 1].callersData[0];
  const formattedData = data.metrics.slice(0, -1);

  return (
    <div className="overflow-auto">
      {pdfMode && (
        <div className="bg-neutral-100 sticky top-0 z-10 grid grid-cols-[1844px] border-t border-t-base-1000 w-fit">
          <Cell title={data.today} type="head" className="text-center" />
        </div>
      )}
      <div
        className={twMerge(
          'bg-neutral-100 sticky z-10 grid grid-cols-[220px_320px_repeat(3,120px)_repeat(2,152px)_repeat(4,120px)_160px] border-y border-y-base-1000 w-fit',
          pdfMode ? 'top-[41px]' : 'top-0',
        )}
      >
        <Cell title="Client" type="head" />
        <Cell title="Caller" type="head" />
        <Cell title="Dials" type="head" />
        <Cell title="Reaches" type="head" />
        <Cell title="Reach Rate %" type="head" />
        <Cell title="Attempted Pitches" type="head" />
        <Cell title="Completed Pitches" type="head" />
        <Cell title="Pitch Rate %" type="head" />
        <Cell title="Booked" type="head" />
        <Cell title="Performed" type="head" />
        <Cell title="More Info" type="head" />
        <Cell title="CTD Perform Rate %" type="head" />
      </div>
      <div
        className={twMerge(
          'bg-neutral-100 sticky z-10 grid grid-cols-[220px_320px_repeat(3,120px)_repeat(2,152px)_repeat(4,120px)_160px] border-b border-b-base-1000 w-fit',
          pdfMode ? 'top-[83px]' : 'top-[42px]',
        )}
      >
        <Cell title="Totals:" type="total" />
        <Cell title="-" type="total" />
        <Cell title={total.dials} type="total" />
        <Cell title={total.reaches} type="total" />
        <Cell title={total.reachRate} type="total" />
        <Cell title={total.attemptedPitches} type="total" />
        <Cell title={total.completedPitches} type="total" />
        <Cell title={total.pitchRate} type="total" />
        <Cell title={total.booked} type="total" />
        <Cell title={total.performed} type="total" />
        <Cell title={total.moreInfo} type="total" />
        <Cell title="-" type="total" />
      </div>
      {formattedData.map(({ company, callersData }, idx) => (
        <div
          key={idx}
          className="grid grid-cols-[220px_1fr] border-b border-b-base-400 w-fit"
        >
          <Cell title={company} type="body" />
          <div>
            {callersData.map((v, idx) => {
              const isLast = callersData.length - 1 === idx;

              return (
                <div
                  key={idx}
                  className={twMerge(
                    'grid grid-cols-[320px_repeat(3,120px)_repeat(2,152px)_repeat(4,120px)_160px] w-fit',
                    !isLast && 'border-b border-b-base-400',
                  )}
                >
                  <Cell title={v.fullName} type="body" />
                  <Cell title={v.dials} type="body" />
                  <Cell title={v.reaches} type="body" />
                  <Cell title={v.reachRate} type="body" />
                  <Cell title={v.attemptedPitches} type="body" />
                  <Cell title={v.completedPitches} type="body" />
                  <Cell title={v.pitchRate} type="body" />
                  <Cell title={v.booked} type="body" />
                  <Cell title={v.performed} type="body" />
                  <Cell title={v.moreInfo} type="body" />
                  <Cell title={v.CTDPerformRate} type="body" />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
